module.exports = __webpack_public_path__ + "static/media/xray1.707fc034.jpg";